import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Kevlar2ProgressComponent } from './kevlar2-progress.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export function loadEcharts() { return import('echarts'); }

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        MatProgressBarModule,
        NgxEchartsModule.forRoot({ echarts: loadEcharts })
    ],
    declarations: [
        Kevlar2ProgressComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class Kevlar2ProgressModule {}